<template>
    <div class="graph-wrapper" :style="graphWrapperStyle">
        <ErrorOverlay
            v-if="errorMessage"
            :title="'KPI No Disponible'"
            :message="errorMessage"
            :fontScale="0.5"
        ></ErrorOverlay>
        <div class="spinner-wrapper" v-if="isLoading">
            <SpeenComponent
                :isAutomatic="true"
                :ringWidth="14"
                :isVerticalAligned="true"
                :resizeable="true"
            />
        </div>
        <KPIGraph
            v-if="kpiData && machineType != 3"
            :machineId="Number(kpiData.id)"
            :ref="`kpi_${kpiData.id}`"
        ></KPIGraph>
        <!-- <ScaleGraph
            v-if="kpiData && machineType == 2"
            :machineId="Number(kpiData.id)"
            :ref="`bascula_${kpiData.id}`"
        ></ScaleGraph>

        <TrackingGraph
            v-if="kpiData && machineType == 3"
            :machineId="Number(kpiData.id)"
            :ref="`bascula_${kpiData.id}`"
        ></TrackingGraph> -->
    </div>
</template>

<script>
import KPIGraph from "./KPIGraph";
import ScaleGraph from "./ScaleGraph";
import SpeenComponent from "./SpeenComponent";
import { mapGetters, mapActions } from 'vuex';
import ErrorOverlay from "./ErrorOverlay";
import TrackingGraph from "./TrackingGraph";
export default {
    name: "MachineMonitorizationGraph",
    components:{
        TrackingGraph,
        ErrorOverlay,
        KPIGraph,
        ScaleGraph,
        SpeenComponent
    },
    props:{
        machineId: Number,
        uniqueMachineGraph:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {}
    },
    methods:{
        existsProperty(obj, propertyName){
            return obj.hasOwnProperty(propertyName) && obj[propertyName] != null;
        }
    },
    mounted(){
    },
    computed:{
        ...mapGetters('monitorization', ['activeMachineById']),
        isLoading(){
            //Se comprueba si tiene algun campo mas que los iniciales, o si ha dado error
            return !this.kpiData?.hasOwnProperty('shift') && !this.errorMessage;
        },
        kpiData(){
            return this.activeMachineById(this.machineId);
        },
        machineType(){
            return  this.kpiData && this.kpiData.hasOwnProperty('machine')? this.kpiData.machine.machine_type_id : 1;
        },
        graphWrapperStyle(){
            return this.uniqueMachineGraph? {
                border: 'none'
            }: {}
        },
        errorMessage(){
            let activeMachineData = this.activeMachineById(this.machineId)
            return activeMachineData && activeMachineData.hasOwnProperty('error')?activeMachineData.error:false;
        }
    }
}
</script>

<style >

</style>
